import { Alert } from "react-native";
import type { ContextType as AlertContextType } from "~/components/AlertProvider/AlertContext";
import type { AlertButton } from "react-native";

/**
 * returns a promise that resolves either with true or false, depending
 * on wheather the user accepts or dismisses the prompt
 */

const promptYesNo = (
  {
    title,
    message,
    yesText = "Yes",
    noText = "No",
    yesStyle = "default",
    noStyle = "cancel",
  }: {
    title: string;
    message: string;
    yesText?: string;
    noText?: string;
    yesStyle?: AlertButton["style"];
    noStyle?: AlertButton["style"];
  },
  alert = Alert.alert as AlertContextType["alert"],
): Promise<boolean> =>
  new Promise((resolve) => {
    alert(
      title,
      message,
      [
        { text: noText, style: noStyle, onPress: () => resolve(false) },
        { text: yesText, style: yesStyle, onPress: () => resolve(true) },
      ],
      undefined,
      { cancelable: false, onDismiss: () => resolve(false) },
    );
  });

export { promptYesNo };
